import React from 'react';

import { Button, Flex, Heading, Text } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';

import { TrainingNeedsPills } from '../../../components/TrainingNeedsPills/TrainingNeedsPills';

type DesktopTrainingNeedsInput = {
  skills: string[];
  behaviors: string[];
  handleDesktopBehaviorsClick: (behaviors: string[]) => void;
  handleDesktopSkillsClick: (skills: string[]) => void;
  resetFields: () => void;
};

export const DesktopTrainingNeedsInput = ({
  skills,
  behaviors,
  handleDesktopBehaviorsClick,
  handleDesktopSkillsClick,
  resetFields,
}: DesktopTrainingNeedsInput): JSX.Element => {
  const theme = useTheme();

  return (
    <>
      <Flex borderTop={`8px solid ${theme.background.secondary}`} sx={{ marginX: '-10px' }} />
      <Flex alignItems="center" justifyContent="space-between" mt="4x" mb="2x">
        <Heading size="300" textAlign="center" marginBottom="0x">
          Filters
        </Heading>
        <Button
          variant="flat"
          onClick={resetFields}
          size="small"
          sx={{
            '&:hover, &:focus': { background: 'none' },
          }}
        >
          Reset all
        </Button>
      </Flex>
      <Text size="100" textColor="tertiary" mb="5x">
        Adjust your search according to your needs.
      </Text>
      <TrainingNeedsPills
        title="What training needs do you have?"
        subtitle="We'll show trainers with relevant experience."
        selectedSkills={skills}
        selectedBehaviors={behaviors}
        behaviorsOnChange={handleDesktopBehaviorsClick}
        skillsOnChange={handleDesktopSkillsClick}
        titleSize="100"
      />
    </>
  );
};
